import type {ReactElement} from 'react';
import type {StoryProgressRailProps} from './story-progress-rail.types';
import {MAX_STORY_PROGRESS_SEGMENTS} from './story-progress-rail.types';
import styles from './story-progress-rail.module.scss';

export function StoryProgressRail({numberOfPages}: StoryProgressRailProps): ReactElement {
  const getProgressSegments = (): ReactElement[] => {
    return getProgressSegmentIndexes().map(
      (segmentIndex: number): ReactElement => (
        <span className={styles.storyProgressSegment} key={`story-progress-segment-${segmentIndex}`}>
          {getProgressFill(segmentIndex)}
        </span>
      )
    );
  };

  const getProgressSegmentIndexes = (): number[] => {
    const segmentCount = Math.min(Math.max(numberOfPages, 1), MAX_STORY_PROGRESS_SEGMENTS);
    return Array.from({length: segmentCount}).map((_unusedEntry: unknown, segmentIndex: number): number => segmentIndex);
  };

  const getProgressFill = (segmentIndex: number): ReactElement | null => {
    if (segmentIndex !== 0) {
      return null;
    }

    return <span className={styles.storyProgressFill} />;
  };

  return (
    <div className={styles.storyProgressRail} aria-hidden="true">
      {getProgressSegments()}
    </div>
  );
}
